<ng-template #templateBillingSupplierDetail>
    <div class="modal-billing-supplier-detail">
        <div class="modal-header">
            <div class="d-flex flex-column">
                <h4 class="modal-title">{{ 'support.faturamento-fornecedores.billing-detail.header.title.' + (holdingPaymentType == HoldingPaymentTypeEnum.Opportunity ? 'quotation' : 'order') | translate: { paymentType: holdingPaymentTypeDescription } }}</h4>
                <span class="modal-subtitle">
                    <span>{{ 'support.faturamento-fornecedores.billing-detail.header.subtitle' | translate: { name: holdingName } }}</span>
                </span>
            </div>
            <div class="search-section">
                <form class="input-group">
                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                    <input type="text" maxlength="100" [placeholder]="'support.faturamento-fornecedores.billing-detail.header.filter.' + (holdingPaymentType == HoldingPaymentTypeEnum.Opportunity ? 'quotation' : 'order') | translate" class="form-control" name="search" [(ngModel)]="filter" />
                </form>
            </div>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="close();"></button>
        </div>
        <div class="modal-body">
            <div class="content">
                @if (holdingCashbackInfoList.length > 0) {
                    <div class="header">
                        @if (holdingPaymentType == HoldingPaymentTypeEnum.Opportunity) {
                            <div class="col-cashback-info col-quotation-id justify-content-center">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.title.quotation-id' | translate }}
                            </div>
                            <div class="col-cashback-info col-repairer-name-large">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.title.repairer' | translate }}
                            </div>
                            <div class="col-cashback-info col-order-date justify-content-end">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.title.order-date' | translate }}
                            </div>
                            <div class="col-cashback-info col-opportunity-cost justify-content-end">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.title.opportunity-cost' | translate }}
                            </div>
                        } @else {
                            <div class="col-cashback-info col-order-id justify-content-center">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.title.order-id' | translate }}
                            </div>
                            <div class="col-cashback-info col-repairer-name">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.title.repairer' | translate }}
                            </div>
                            <div class="col-cashback-info col-order-date">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.title.order-date' | translate }}
                            </div>
                            <div class="col-cashback-info col-cashback-type justify-content-center">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.title.cashback-type' | translate }}
                            </div>
                            @if (holdingPaymentType == HoldingPaymentTypeEnum.Order) {
                                <div class="col-cashback-info col-taxes justify-content-end">
                                    <span>{{ 'support.faturamento-fornecedores.billing-detail.table.title.rebate-tax' | translate }}</span>
                                </div>
                            } @else {
                                <div class="col-cashback-info col-taxes col-with-two-lines">
                                    <span>{{ 'support.faturamento-fornecedores.billing-detail.table.title.commission-tax' | translate }}</span>
                                    <small>{{ 'support.faturamento-fornecedores.billing-detail.table.title.rebate-tax' | translate }}</small>
                                </div>
                            }
                            <div class="col-cashback-info col-order-value col-with-two-lines">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.title.order-value' | translate }}
                                <small>{{ 'support.faturamento-fornecedores.billing-detail.table.title.order-value-original' | translate }}</small>
                            </div>
                            <div class="col-cashback-info col-comission justify-content-end">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.title.' + (holdingPaymentType == HoldingPaymentTypeEnum.Order ? 'order-cost' : 'commission-value') | translate }}
                            </div>
                            <div class="col-cashback-info col-cashback-value col-with-two-lines">
                                <span>{{ 'support.faturamento-fornecedores.billing-detail.table.title.cashback-value.title' | translate }}</span>
                                <span>{{ 'support.faturamento-fornecedores.billing-detail.table.title.cashback-value.subtitle' | translate }}</span>
                            </div>
                            <div class="col-cashback-info col-line-total justify-content-end">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.title.total' | translate }}
                            </div>
                        }
                    </div>
                    <ng-scrollbar>
                        @for (holdingCashbackInfo of filteredHoldingCashbackInfoList; track holdingCashbackInfo) {
                            <div class="part">
                                @if (holdingPaymentType == HoldingPaymentTypeEnum.Opportunity) {
                                    <div class="col-cashback-info col-quotation-id justify-content-center">
                                        {{ holdingCashbackInfo.quotationId }}
                                    </div>
                                    <div class="col-cashback-info col-repairer-name-large">
                                        <span class="truncate">{{ holdingCashbackInfo.repairerName }}</span>
                                    </div>
                                    <div class="col-cashback-info col-order-date justify-content-end">
                                        {{ holdingCashbackInfo.creationDate | date: 'dd/MM/yyyy' }}
                                    </div>
                                    <div class="col-cashback-info col-opportunity-cost justify-content-end">
                                        {{ holdingCashbackInfo.comissionPayable | currency:'R$' }}
                                    </div>
                                } @else {
                                    <div class="col-cashback-info col-order-id justify-content-center">
                                        {{ holdingCashbackInfo.orderId }}
                                    </div>
                                    <div class="col-cashback-info col-repairer-name">
                                        <span class="truncate">{{ holdingCashbackInfo.repairerName }}</span>
                                    </div>
                                    <div class="col-cashback-info col-order-date">
                                        {{ holdingCashbackInfo.orderDate | date: 'dd/MM/yyyy' }}
                                    </div>
                                    <div class="col-cashback-info col-cashback-type justify-content-center">
                                        {{ holdingCashbackInfo.cashbackTypeDescription}}
                                    </div>
                                    <div class="col-cashback-info col-taxes col-with-two-lines">
                                        @if (holdingPaymentType == HoldingPaymentTypeEnum.Order) {
                                            <span>{{ holdingCashbackInfo.rebateTax | number: '.2'}} %</span>
                                        } @else {
                                            <span>{{ holdingCashbackInfo.comissionTax | number: '.2'}} %</span>

                                            @if (holdingCashbackInfo.cashbackType == CashbackTypeEnum.Padronizado) {
                                                <small>{{ holdingCashbackInfo.rebateTax | number: '.2'}} %</small>
                                            }
                                        }
                                    </div>
                                    <div class="col-cashback-info col-order-value col-with-two-lines">
                                        {{ holdingCashbackInfo.orderValue | currency:'R$' }}

                                        @if (holdingCashbackInfo.cashbackType == CashbackTypeEnum.Customizado) {
                                            <small>{{ holdingCashbackInfo.originalOrderValue | currency:'R$' }}</small>
                                        }
                                    </div>
                                    <div class="col-cashback-info col-comission justify-content-end">
                                        {{ holdingCashbackInfo.comissionPayable | currency:'R$' }}
                                    </div>
                                    <div class="col-cashback-info col-cashback-value justify-content-end">
                                        {{ holdingCashbackInfo.cashbackValue | currency:'R$' }}
                                    </div>
                                    <div class="col-cashback-info col-line-total justify-content-end">
                                        {{ holdingCashbackInfo.total | currency:'R$' }}
                                    </div>
                                }
                            </div>
                        }
                    </ng-scrollbar>
                    <div class="footer">
                        @if (holdingPaymentType != HoldingPaymentTypeEnum.Opportunity) {
                            <div class="col-cashback-info col-total-summary">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.footer.totals' | translate }}
                            </div>
                            <div class="col-cashback-info col-order-value  justify-content-end">
                                {{ orderValueSum | currency: 'R$' }}
                            </div>
                            <div class="col-cashback-info col-comission  justify-content-end">
                                {{ comissionPayableValueSum | currency: 'R$' }}
                            </div>
                            <div class="col-cashback-info col-cashback-value justify-content-end">
                                {{ cashbackValueSum | currency: 'R$' }}
                            </div>
                        } @else {
                            <div class="col-cashback-info col-quantity">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.footer.quotation-count' | translate: { quantity: holdingCashbackInfoList.length } }}
                            </div>
                            <div class="col-cashback-info col-total-summary-large justify-content-end">
                                {{ 'support.faturamento-fornecedores.billing-detail.table.footer.totals' | translate }}
                            </div>
                        }

                        <div class="col-cashback-info col-line-total justify-content-end">
                            {{ totalValueSum | currency: 'R$' }}
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    <ngx-ui-loader [loaderId]="'loader-supplier-cashback-info'"></ngx-ui-loader>
</ng-template>
